import WavyBackground from '@gc-bridge/assets/images/wavy-background_shared.png';
import { LinkButton } from '@gc-bridge/components/Button/Link';
import { CenteredContainer } from '@gc-bridge/components/Container/Centered';
import { AdditionalColors } from '@gc-bridge/theme/colors';
import { ReportGmailerrorred } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';

interface Props {
  title: string;
  content: string;
  buttonLabel: string;
  buttonUrl: string;
}

export function ErrorButtonPage({ title, content, buttonLabel, buttonUrl }: Props) {
  return (
    <CenteredContainer backgroundImage={WavyBackground}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '5px',
        }}
      >
        <ReportGmailerrorred fontSize="large" color="error" />
        <Typography fontSize="32px" color="text.primary" lineHeight="35px">
          {title}
        </Typography>
      </Box>
      <Typography
        fontSize="18px"
        color={AdditionalColors.BlackOpacity50}
        maxWidth="60%"
        textAlign="center"
      >
        {content}
      </Typography>
      <LinkButton label={buttonLabel} url={buttonUrl} />
    </CenteredContainer>
  );
}
